import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import styled from '@emotion/styled';
import carousel_scooter from '../../assets/carousel_scooter.svg';
import './../../styles/components/MarketPlace/ReusableCarousel.scss';
import left_icon from '../../assets/left_icon_blue.svg';
import right_icon from '../../assets/right_icon_blue.svg';
import { random_male_names } from '../../constants/MarketplaceConstants';
import { random_city_names } from '../../constants/MarketplaceConstants';
import { random_client_names } from '../../constants/MarketplaceConstants';
import { useMitraDispatch } from '../../contexts/MitraContext';

const ReusableCarouselContainer = styled('div')(props => ({
  color: props.color ? props.color : '#3C3C3C',
  textAlign: 'left',
  height: '100%',

  '.slider-container': {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '0px',
    left: '0px',
  },

  '.carousel .slider-wrapper': {
    height: '100% !important',
  },
  '.carousel .slide': {
    textAlign: 'left !important',
    // overflow: 'hidden',
    // whiteSpace: 'nowrap',
    // textOverflow: 'ellipsis',
    fontWeight: 600,
    fontSize: '11px',
    lineHeight: '16px',
  },

  '.carousel .slide img': {
    // width: '24px !important',
    // height: '24px !important',
  },

  '.carousel-content-parent': {
    background: props.background ? props.background : '#FFF1D2',
    padding: '12px 18px',
    maxHeight: '78px',
    display: 'flex',
    alignItems: 'center',

    '.carousel-content-text': {
      marginLeft: '12px',
      marginRight: '5px',
      //   overflow: 'hidden',
      //   whiteSpace: 'nowrap',
      //   textOverflow: 'ellipsis',
    },
  },

  '.carousel-content-img': {
    width: '24px !important',
    height: '24px !important',
    marginLeft: '22px',
  },
}));

const arrowStyles = {
  position: 'absolute',
  zIndex: 2,
  top: 'calc(50% - 10px)',
  width: 18,
  height: 18,
  cursor: 'pointer',
  border: 'none',
  margin: '0px 8px',
};

const ReusableCarousel = ({ carouselProps, currentCity }) => {
  const { actions: MitraActions } = useMitraDispatch();
  const { setJobListingsCarouselContent } = MitraActions;
  const [carouselPropsCopy, setCarouselPropsCopy] = useState(carouselProps);

  useEffect(() => {
    setCarouselPropsCopy(carouselProps);
    for (let g = 0; g < carouselPropsCopy.carouselContent.length; g++) {
      carouselPropsCopy.carouselContent[g].displayText = renderCarouselTxt(
        carouselPropsCopy.carouselContent[g]
      );
    }
  }, []);

  const renderCarouselTxt = item => {
    if (item.isDynamic) {
      var result = getFromBetween.get(item.text, '{', '}');
      return result;
    } else {
      return item.text;
    }
  };

  var getFromBetween = {
    results: [],
    string: '',
    getFromBetween: function(sub1, sub2) {
      if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
      var SP = this.string.indexOf(sub1) + sub1.length;
      var string1 = this.string.substr(0, SP);
      var string2 = this.string.substr(SP);
      var TP = string1.length + string2.indexOf(sub2);
      return this.string.substring(SP, TP);
    },
    removeFromBetween: function(sub1, sub2) {
      if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
      var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
      this.string = this.string.replace(removal, replaceWithDynamicContent(removal));
      console.log('STR RESULT', this.string);
    },
    getAllResults: function(sub1, sub2) {
      // first check to see if we do have both substrings
      if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

      // find one result
      var result = this.getFromBetween(sub1, sub2);
      // push it to the results array
      this.results.push(result);
      // this.string.replace(result, "test");
      // remove the most recently found one from the string
      this.removeFromBetween(sub1, sub2);

      // if there's more substrings
      if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
        this.getAllResults(sub1, sub2);
      } else return;
    },
    get: function(string, sub1, sub2) {
      this.results = [];
      this.string = string;
      this.getAllResults(sub1, sub2);
      return this.string;
    },
  };

  const replaceWithDynamicContent = content => {
    content = content.replace('{', '');
    content = content.replace('}', '');
    if (content.includes('-')) {
      return checkIfRandomNumberExists(content);
    } else if (content.includes('name')) {
      return getRandomName();
    } else if (content.includes('city')) {
      return getRandomCity();
    } else if (content.includes('client')) {
      return getRandomClient();
    }
  };

  const checkIfRandomNumberExists = range => {
    if (range.split('_')[1] == 'monthlyReport') {
      var placementNumberFromStorage = JSON.parse(
        localStorage.getItem('jobListingsCarouselContentNumber')
      );

      if (placementNumberFromStorage) {
        var dateString = placementNumberFromStorage.timestamp;
        var now = new Date();
        // var now = placementNumberFromStorage.timestamp;
        var placementCityVal = placementNumberFromStorage.placementCity;
        if (new Date(dateString).getDate() < new Date(now).getDate()) {
          localStorage.removeItem('jobListingsCarouselContentNumber');
          localStorage.removeItem('cityWisePlacementObj');
          //start is less than End or placementNumberFromStorage does not exist
          return getRandomNumberInRange(range, true, true);
        } else if (currentCity !== placementCityVal) {
          return cityExistsInStorage(range);
        } else {
          return placementNumberFromStorage.placementNumber;
        }
      } else {
        return getRandomNumberInRange(range, true, true);
      }
    } else if (range.split('_')[1] == 'workersPlacedWeekly') {
      var workersPlacedWeeklyFromStorage = JSON.parse(
        localStorage.getItem('workersPlacedWeeklyObj')
      );

      if (workersPlacedWeeklyFromStorage) {
        const workersPlacedWeeklyTimestamp = workersPlacedWeeklyFromStorage.timestamp;
        // const workersPlacedWeeklyTimestamp = new Date('03-12-2023');
        const now = new Date();
        const sevenDaysInMs = 7 * 24 * 60 * 60 * 10;
        const timeDiffInMs =
          new Date(now).getTime() - new Date(workersPlacedWeeklyTimestamp).getTime();
        if (timeDiffInMs >= sevenDaysInMs) {
          // console.log('Date is older than 7 days');
          return getRandomNumberInRange(range, false, false, true);
        } else {
          return workersPlacedWeeklyFromStorage.placedNumber;
        }
      } else {
        return getRandomNumberInRange(range, false, false, true);
      }
    }
  };

  const getRandomNumberInRange = (
    range,
    updateLocalStorage = true,
    updateCityArrayInLocalStorage = false,
    updateWorkersPlacedArrayInLocalStorage = false
  ) => {
    var minMaxVals = range.split('-');
    var minVal = parseInt(minMaxVals[0]);
    var maxVal = parseInt(minMaxVals[1]);

    var min = Math.ceil(minVal);
    var max = Math.floor(maxVal);
    var finalVal = Math.floor(Math.random() * (max - min + 1) + min);

    if (updateLocalStorage) {
      // localStorage.setItem('jobListingsCarouselContentNumber', finalVal);
      var placementNumberObj = {
        placementNumber: finalVal,
        timestamp: new Date(),
        placementCity: currentCity,
      };
      localStorage.setItem('jobListingsCarouselContentNumber', JSON.stringify(placementNumberObj));
    }

    if (updateCityArrayInLocalStorage) {
      var cityWisePlacementFromStorage = [];
      var cityWisePlacementObjToAdd = {
        city: currentCity,
        placementNumber: finalVal,
      };
      cityWisePlacementFromStorage.push(cityWisePlacementObjToAdd);
      localStorage.setItem('cityWisePlacementObj', JSON.stringify(cityWisePlacementFromStorage));
    }

    if (updateWorkersPlacedArrayInLocalStorage) {
      var workersPlacedtObjToAdd = {
        placedNumber: finalVal,
        timestamp: new Date(),
      };
      localStorage.setItem('workersPlacedWeeklyObj', JSON.stringify(workersPlacedtObjToAdd));
    }
    return finalVal;
  };

  const cityExistsInStorage = range => {
    var cityExistsInStorageCheck = false;
    var cityWisePlacementFromStorage = JSON.parse(localStorage.getItem('cityWisePlacementObj'))
      ? JSON.parse(localStorage.getItem('cityWisePlacementObj'))
      : [];
    var cityWisePlacementObjToAdd = {
      city: currentCity,
      placementNumber: getRandomNumberInRange(range, false),
    };

    if (cityWisePlacementFromStorage.length > 0) {
      for (let j = 0; j < cityWisePlacementFromStorage.length; j++) {
        if (cityWisePlacementFromStorage[j].city == currentCity) {
          cityExistsInStorageCheck = true;
          var placementNumberObj = {
            placementNumber: cityWisePlacementFromStorage[j].placementNumber,
            timestamp: new Date(),
            placementCity: cityWisePlacementFromStorage[j].city,
          };
          localStorage.setItem(
            'jobListingsCarouselContentNumber',
            JSON.stringify(placementNumberObj)
          );
          return cityWisePlacementFromStorage[j].placementNumber;
        }
      }
      if (!cityExistsInStorageCheck) {
        cityWisePlacementFromStorage.push(cityWisePlacementObjToAdd);
        localStorage.setItem('cityWisePlacementObj', JSON.stringify(cityWisePlacementFromStorage));

        var placementNumberObj = {
          placementNumber: cityWisePlacementObjToAdd.placementNumber,
          timestamp: new Date(),
          placementCity: currentCity,
        };
        localStorage.setItem(
          'jobListingsCarouselContentNumber',
          JSON.stringify(placementNumberObj)
        );
        return cityWisePlacementObjToAdd.placementNumber;
        // getRandomNumberInRange(range);
      }
    } else {
      cityWisePlacementFromStorage.push(cityWisePlacementObjToAdd);
      localStorage.setItem('cityWisePlacementObj', JSON.stringify(cityWisePlacementFromStorage));

      var placementNumberObj = {
        placementNumber: cityWisePlacementObjToAdd.placementNumber,
        timestamp: new Date(),
        placementCity: currentCity,
      };
      localStorage.setItem('jobListingsCarouselContentNumber', JSON.stringify(placementNumberObj));
      return cityWisePlacementObjToAdd.placementNumber;
      // getRandomNumberInRange(range);
    }
  };

  const getRandomName = () => {
    const random = Math.floor(Math.random() * random_male_names.nameList.length);
    return random_male_names.nameList[random];
  };

  const getRandomCity = () => {
    const random = Math.floor(Math.random() * random_city_names.cityList.length);
    // return random_city_names.cityList[random];
    return currentCity;
  };

  const getRandomClient = () => {
    const random = Math.floor(Math.random() * random_client_names.cityList.length);
    return random_client_names.cityList[random];
  };

  return (
    <ReusableCarouselContainer
      background={carouselProps.carouselBackground}
      color={carouselProps.carouselTextColor}
    >
      <Carousel
        dynamicHeight={true}
        infiniteLoop={true}
        showStatus={false}
        showThumbs={false}
        autoPlay={true}
        interval={carouselProps.carouselInterval}
        showIndicators={false}
        className="carousel-parent-div"
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <button
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, left: 8 }}
            >
              <img src={left_icon} alt="" />
            </button>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <button
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, right: 8 }}
            >
              <img src={right_icon} alt="" />
            </button>
          )
        }
      >
        {carouselProps
          ? carouselPropsCopy.carouselContent.map(item => {
              return (
                <div className="carousel-content-parent">
                  <img className="carousel-content-img" src={carousel_scooter} alt="" />
                  <div className="carousel-content-text">{item.displayText}</div>
                </div>
              );
            })
          : null}
      </Carousel>
    </ReusableCarouselContainer>
  );
};

export default ReusableCarousel;
